<template>
  <div class="container-fluid demand-detail-edit-page">
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="demand-edit-wrap">
        <div v-if="!is_editing">
          <button
            type="button"
            @click="
              $router.push({ path: '/manager/recruitment/personalapplication' })
            "
            class="edit"
          >
            <eva-icon name="arrow-back-outline"></eva-icon>
            返回
          </button>
          <button
            type="button"
            @click="editDetail = is_editing = true"
            class="edit"
          >
            <eva-icon name="edit-outline"></eva-icon>
            編輯
          </button>
        </div>

        <div v-if="is_editing">
          <button type="button" @click="cancelEditDemand" class="cancel">
            <eva-icon name="close-outline"></eva-icon>
            取消
          </button>
          <button type="button" @click="handleSubmit(saveDemand)" class="save">
            <eva-icon name="save-outline"></eva-icon>
            儲存
          </button>
        </div>
      </div>
      <!--- 需求單 --->
      <form class="demand-form">
        <div class="tab-content">
          <div class="tab-name">
            <div class="name-inner">需求單</div>
          </div>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th id="no" class="width-15 text-right">
                  <span>單號</span>
                </th>
                <td class="width-35">
                  {{ demandDetail.No }}
                </td>
                <td class="width-15 text-right">
                  <span>狀態</span>
                </td>
                <td class="width-35">
                  {{
                    $common.manpowerDemandStatusFormatter(
                      demandDetail.ManpowerDemandStatus
                    )
                  }}
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>名稱</span>
                </td>
                <td v-if="is_editing" colspan="3">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="text"
                      class="form-control"
                      maxlength="50"
                      v-model="demandDetail.ManpowerDemandName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <td v-else colspan="3">
                  {{ demandDetail.ManpowerDemandName }}
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>申請時間</span>
                </td>
                <td>
                  {{ $common.dateFormatter(demandDetail.ApplicantTime) }}
                </td>
                <td class="text-right">
                  <span>申請者</span>
                </td>
                <td>
                  {{ demandDetail.Applicant }}
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>申請部門</span>
                </td>
                <td colspan="3">
                  {{ demandDetail.DemandDepartment }}
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>履歷類型</span>
                </td>
                <td>
                  <select
                    v-if="is_editing"
                    class="form-control"
                    v-model="demandDetail.ResumeType"
                  >
                    <option :value="null" disabled>請選擇</option>
                    <option
                      v-for="resume in resumeTypeLIst"
                      :key="resume.Type"
                      :value="resume.Type"
                    >
                      {{ resume.Name }}
                    </option>
                  </select>
                  <div v-else>
                    {{ demandDetail.ResumeType }}
                  </div>
                </td>
                <td class="text-right">
                  <span>招募期限</span>
                </td>
                <td v-if="is_editing">
                  <ValidationProvider
                    tag="section"
                    name="招募期限"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <date-picker
                      class="w-100"
                      format="YYYY-MM-DD"
                      valueType="format"
                      :disabled-date="$common.disabledDateBeforeToday"
                      v-model="demandDetail.RecruitmentDeadline"
                    >
                    </date-picker>
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <td v-else>
                  {{ $common.dateFormatter(demandDetail.RecruitmentDeadline) }}
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>聘僱合約類別</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing" class="form-group">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="一般"
                          v-model="demandDetail.ContractType"
                        />
                        一般
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="競業禁止"
                          v-model="demandDetail.ContractType"
                        />
                        競業禁止
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="鐘點計時"
                          v-model="demandDetail.ContractType"
                        />
                        鐘點計時
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          value="定期合約"
                          v-model="demandDetail.ContractType"
                        />
                        定期合約
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    {{ demandDetail.ContractType }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">招募方式</td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div class="form-group">
                      <div
                        v-for="item in recruitmentMethod"
                        :key="item.RecruitmentMethodGuid"
                        class="form-check form-check-inline"
                      >
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :value="item"
                            v-model="
                              demandDetail.ManpowerDemandRecruitmentMethod
                            "
                          />
                          {{ item.RecruitmentMethod }}
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <div
                        v-if="recruitmentMethodOtherStatus"
                        style="margin-top: 10px"
                      >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <textarea
                            type="text"
                            class="form-control"
                            maxlength="100"
                            @compositionstart="is_composing = true"
                            @compositionend="is_composing = false"
                            v-model="recruitmentMethodDescription"
                          />
                          <span
                            v-if="errors[0] && !is_composing"
                            class="text-danger"
                          >
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <span v-if="recruitmentMethodStatus">不拘</span>
                    <template v-else>
                      <span
                        v-for="item in showRecruitmentMethod"
                        :key="item.RecruitmentMethodGuid"
                        >{{
                          item.RecruitmentMethodDescription
                            ? `其他：${item.RecruitmentMethodDescription}`
                            : item.RecruitmentMethod
                        }}<br />
                      </span>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>職務性質</span>
                </td>
                <td>
                  <div v-if="is_editing" class="form-group">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="全職"
                          v-model="demandDetail.PositionProperty"
                        />
                        全職
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="兼職"
                          v-model="demandDetail.PositionProperty"
                        />
                        兼職
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="高階"
                          v-model="demandDetail.PositionProperty"
                        />
                        高階
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    {{ demandDetail.PositionProperty }}
                  </div>
                </td>
                <td class="text-right">
                  <span>{{ i18n("Position.PositionName") }}</span>
                </td>
                <td>
                  <div v-if="is_editing">
                    <ValidationProvider
                      rules="required"
                      :name="i18n('Position.PositionName')"
                      v-slot="{ errors }"
                    >
                      <v-select
                        :options="positionList"
                        label="PositionName"
                        v-model="positionValue"
                      >
                      </v-select>
                      <span v-if="errors[0]" class="text-danger">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    {{ demandDetail.PositionName }}
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>需求人數</span>
                </td>
                <td>
                  <div v-if="is_editing">
                    <ValidationProvider
                      rules="min_value:1|required|"
                      name="需求人數"
                      v-slot="{ errors }"
                    >
                      <input
                        type="number"
                        class="form-control"
                        min="1"
                        v-model.number="demandDetail.DemandNumber"
                      />
                      <span v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                  <div v-else>{{ demandDetail.DemandNumber }} 人</div>
                </td>

                <td class="text-right">
                  <span>預定任職日</span>
                </td>
                <td v-if="is_editing">
                  <date-picker
                    class="w-100"
                    :disabled-date="$common.disabledDateBeforeToday"
                    v-model="demandDetail.OnBoard"
                    format="YYYY-MM-DD"
                    valueType="format"
                  >
                  </date-picker>
                </td>
                <td v-else>
                  <div v-if="demandDetail.OnBoard">
                    {{ $common.dateFormatter(demandDetail.OnBoard) }}
                  </div>
                  <div v-else>不拘</div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>年齡</span>
                </td>

                <td>
                  <div v-if="is_editing">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="demandDetail.AgeRangeWhatever"
                        />
                        不拘
                      </label>
                    </div>
                    <div v-if="!demandDetail.AgeRangeWhatever" class="form-row">
                      <div class="col-md">
                        <ValidationProvider
                          tag="section"
                          name="年齡"
                          v-slot="{ errors }"
                          rules="min_value:18|max_value:80|required"
                        >
                          <input
                            type="number"
                            class="form-control"
                            min="18"
                            max="80"
                            v-model.number="demandDetail.AgeRangeStart"
                          />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      ~
                      <div class="col-md">
                        <ValidationProvider
                          tag="section"
                          name="年齡"
                          v-slot="{ errors }"
                          rules="min_value:18|max_value:80|required"
                        >
                          <input
                            type="number"
                            class="form-control"
                            min="18"
                            max="80"
                            v-model.number="demandDetail.AgeRangeEnd"
                          />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="demandDetail.AgeRangeWhatever">不拘</div>
                    <div v-else>
                      {{ demandDetail.AgeRangeStart }}～{{
                        demandDetail.AgeRangeEnd
                      }}
                    </div>
                  </div>
                </td>
                <td class="text-right">
                  <span>性別</span>
                </td>
                <td>
                  <div v-if="is_editing">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="不拘"
                          v-model="demandDetail.Sex"
                        />
                        不拘
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="男"
                          v-model="demandDetail.Sex"
                        />
                        男
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="女"
                          v-model="demandDetail.Sex"
                        />
                        女
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    {{ demandDetail.Sex }}
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>出差</span>
                </td>
                <td>
                  <div v-if="is_editing" class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="demandDetail.BusinessTrip"
                      />
                      需要
                    </label>
                  </div>
                  <div v-else>
                    {{ !demandDetail.BusinessTrip ? "否" : "是" }}
                  </div>
                </td>
                <td class="text-right">
                  <span>外派</span>
                </td>
                <td>
                  <div v-if="is_editing" class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="demandDetail.OverseasWork"
                      />
                      需要
                    </label>
                  </div>
                  <div v-else>
                    {{ !demandDetail.OverseasWork ? "否" : "是" }}
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>管理責任</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div class="form-inline">
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="demandDetail.ManagementResponsibility"
                        />
                        需要 (若勾選，請填寫管理人數)
                      </label>
                    </div>
                    <div
                      v-if="demandDetail.ManagementResponsibility"
                      class="form-inline"
                    >
                      <ValidationProvider
                        class="w-100"
                        rules="min_value:1|required"
                        name="管理人數"
                        v-slot="{ errors }"
                      >
                        <input
                          type="number"
                          min="1"
                          class="form-control w-100"
                          v-model="demandDetail.ManagementNumber"
                        />
                        <div>
                          <span class="text-danger" v-if="errors[0]">{{
                            errors[0]
                          }}</span>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="demandDetail.ManagementResponsibility">
                      {{ demandDetail.ManagementNumber }} 人
                    </span>
                    <span v-else>無</span>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right">
                  <span>輪班</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing" class="form-check form-check-inline">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="demandDetail.Shift"
                      />
                      需要
                    </label>
                  </div>
                  <div v-else>
                    {{ !demandDetail.Shift ? "否" : "是" }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>班別</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div
                      v-for="item in newWorkingHours"
                      :key="item.WorkShiftTypeGuid"
                      class="form-check"
                    >
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :value="item"
                          v-model="demandDetail.ManpowerDemandWorkShiftType"
                        />
                        {{ item.WorkShiftType }}
                      </label>
                      <input
                        type="text"
                        class="form-control w-100"
                        placeholder="請填寫詳細時段或排班資訊"
                        v-model="item.WorkShiftTypeDescription"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="workingHoursStatus">不拘</span>
                    <template v-else>
                      <span
                        v-for="item in showWorkShiftType"
                        :key="item.WorkShiftTypeGuid"
                      >
                        <strong>{{ item.WorkShiftType }}</strong
                        >，時段：{{ item.WorkShiftTypeDescription }} <br />
                      </span>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>工作地點</span>
                </td>
                <td v-if="is_editing" colspan="3">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <multiselect
                      :options="workplaceList"
                      :close-on-select="false"
                      :multiple="true"
                      selectLabel=""
                      selectedLabel=""
                      deselectLabel=""
                      track-by="WorkPlaceGuid"
                      label="WorkPlace"
                      placeholder="請選擇"
                      v-model="demandDetail.ManpowerDemandWorkPlace"
                    />
                    <span
                      v-if="errors[0] && !is_composing"
                      class="text-danger ml-1"
                    >
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <td v-if="!is_editing" colspan="3">
                  <span
                    v-for="(
                      item, index
                    ) in demandDetail.ManpowerDemandWorkPlace"
                    :key="item.WorkPlaceGuid"
                  >
                    <span v-if="index > 0">、</span>{{ item.WorkPlace }}
                  </span>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>工作內容</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <ValidationProvider
                      rules="required"
                      name="工作內容"
                      v-slot="{ errors }"
                    >
                      <textarea
                        class="form-control"
                        rows="8"
                        @compositionstart="is_composing = true"
                        @compositionend="is_composing = false"
                        v-model="demandDetail.WorkContent"
                      />
                      <span
                        v-if="errors[0] && !is_composing"
                        class="text-danger ml-1"
                        >{{ errors[0] }}</span
                      >
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    <pre>{{ demandDetail.WorkContent }}</pre>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>說明</span>
                </td>
                <td colspan="3">
                  <textarea
                    v-if="is_editing"
                    class="form-control"
                    rows="5"
                    v-model="demandDetail.Description"
                  ></textarea>
                  <div v-else>
                    <pre>{{ demandDetail.Description }}</pre>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>薪資類型</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-select
                        class="w-100"
                        :options="salaryTypeList"
                        label="Name"
                        placeholder="請選擇"
                        v-model="salaryTypeValue"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                      v-if="salaryTypeValue && salaryTypeValue.Code === 'other'"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        class="form-control"
                        style="margin-top: 5px"
                        placeholder="請填寫薪資類型"
                        v-model="demandDetail.SalaryTypeDescription"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    {{
                      demandDetail.SalaryTypeDescription
                        ? demandDetail.SalaryTypeDescription
                        : demandDetail.SalaryType
                    }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>薪資待遇</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div class="form-row">
                      <div class="col-md">
                        <ValidationProvider
                          tag="section"
                          name="薪資待遇(低)"
                          :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                          v-slot="{ errors }"
                        >
                          <input
                            type="text"
                            class="form-control text-right"
                            v-model.trim="demandDetail.SalaryLow"
                          />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      ~
                      <div class="col-md">
                        <ValidationProvider
                          tag="section"
                          name="薪資待遇(高)"
                          :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                          v-slot="{ errors }"
                        >
                          <input
                            type="text"
                            class="form-control text-right"
                            v-model.trim="demandDetail.SalaryHigh"
                          />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    {{ demandDetail.SalaryLow }} {{ demandDetail.SalaryHigh ? '~' + demandDetail.SalaryHigh : "" }}
                  </div>
                </td>
              </tr>

              <!-- 預設職稱 -->
              <tr v-if="demandDetail.ResumeType === 'DL'">
                <td colspan="1" class="text-right">
                  <span>預設職稱</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <el-select
                      class="w-100"
                      placeholder="請選擇"
                      v-model="demandDetail.AppointmentDefaultPosition"
                    >
                      <el-option label="生產助理員" value="生產助理員" />
                      <el-option label="助理" value="助理" />
                      <el-option label="技術助理員" value="技術助理員" />
                      <el-option label="技術員" value="技術員" />
                      <el-option label="高級技術員" value="高級技術員" />
                      <el-option label="事務員" value="事務員" />
                      <el-option label="資深技術員" value="資深技術員" />
                      <el-option label="組長" value="組長" />
                      <el-option label="儲備組長" value="儲備組長" />
                      <el-option label="工讀生" value="工讀生" />
                      <el-option label="實習生" value="實習生" />
                      <el-option label="按摩師" value="按摩師" />
                    </el-select>
                  </div>
                  <div v-else>
                    {{ demandDetail.AppointmentDefaultPosition }}
                  </div>
                </td>
              </tr>

              <!-- 預設職等 -->
              <tr v-if="demandDetail.ResumeType === 'DL'">
                <td colspan="1" class="text-right">
                  <span>預設職等</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <el-select
                      class="w-100"
                      placeholder="請選擇"
                      v-model="demandDetail.AppointmentDefaultRank"
                    >
                      <el-option label="1" value="1" />
                      <el-option label="2" value="2" />
                      <el-option label="2.1" value="2.1" />
                      <el-option label="2.2" value="2.2" />
                      <el-option label="3" value="3" />
                      <el-option label="4" value="4" />
                      <el-option label="5" value="5" />
                      <el-option label="6" value="6" />
                      <el-option label="6.3" value="6.3" />
                      <el-option label="7" value="7" />
                      <el-option label="7.3" value="7.3" />
                      <el-option label="8" value="8" />
                      <el-option label="8.3" value="8.3" />
                      <el-option label="9" value="9" />
                      <el-option label="9.3" value="9.3" />
                      <el-option label="10" value="10" />
                      <el-option label="10.3" value="10.3" />
                      <el-option label="10.5" value="10.5" />
                      <el-option label="10.7" value="10.7" />
                      <el-option label="11" value="11" />
                      <el-option label="11.3" value="11.3" />
                      <el-option label="11.5" value="11.5" />
                      <el-option label="12" value="12" />
                      <el-option label="13" value="13" />
                      <el-option label="13.3" value="13.3" />
                    </el-select>
                  </div>
                  <div v-else>
                    {{ demandDetail.AppointmentDefaultRank }}
                  </div>
                </td>
              </tr>

              <!-- 預設薪資 -->
              <tr>
                <td colspan="1" class="text-right">
                  <span>預設薪資</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <ValidationProvider
                      name="預設薪資"
                      :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                      v-slot="{ errors }"
                    >
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model.trim="demandDetail.AppointmentDefaultSalary"
                      />
                      <span
                        v-if="errors[0] && !is_composing"
                        class="text-danger ml-1"
                      >
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    {{ demandDetail.AppointmentDefaultSalary }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>職務聯絡人</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <ValidationProvider
                      class="w-100"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <multiselect
                        class="w-100"
                        :options="supervisorOptions"
                        label="Name"
                        placeholder="請選擇"
                        track-by="Email"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        :taggable="true"
                        @tag="addPositionContactorTag"
                        v-model="demandDetail.PositionContactor"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    {{
                      demandDetail.PositionContactor
                        ? demandDetail.PositionContactor.Name
                        : null
                    }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>聯絡人Email</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <ValidationProvider
                      class="w-100"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <input
                        class="form-control w-100"
                        type="text"
                        v-model="demandDetail.PositionContactorEmail"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div v-else>
                    {{ demandDetail.PositionContactorEmail }}
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>工作經歷</span>
                </td>

                <td colspan="3">
                  <div v-if="is_editing">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="demandDetail.WorkExperienceWhatever"
                        />
                        不拘 (若不勾選，請填寫年資)
                      </label>
                    </div>
                    <div
                      v-if="!demandDetail.WorkExperienceWhatever"
                      class="form-inline"
                    >
                      <ValidationProvider
                        class="w-100"
                        name="年資"
                        rules="min_value:1|required"
                        v-slot="{ errors }"
                      >
                        <input
                          class="form-control w-100"
                          type="number"
                          min="1"
                          v-model.number="demandDetail.WorkExperience"
                        />
                        <p v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="demandDetail.WorkExperienceWhatever">不拘</span>
                    <span v-else>{{ demandDetail.WorkExperience }} 年</span>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>學歷</span>
                </td>

                <td colspan="3">
                  <div v-if="is_editing">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="demandDetail.EducationDemandWhatever"
                        />
                        不拘
                      </label>
                    </div>
                    <div v-if="!demandDetail.EducationDemandWhatever">
                      <ValidationProvider rules="required" v-slot="{ failed }">
                        <div
                          v-for="item in educationDegree"
                          :key="item.Guid"
                          class="form-check form-check-inline"
                        >
                          <label class="form-check-label">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              :value="item"
                              v-model="
                                demandDetail.ManpowerDemandEducationDegree
                              "
                            />
                            {{ item.EducationDegree }}
                          </label>
                        </div>
                        <span class="text-danger ml-2" v-if="failed">
                          請選擇學歷
                        </span>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div v-else>
                    <span v-if="demandDetail.EducationDemandWhatever">
                      不拘
                    </span>
                    <template v-else>
                      <span
                        v-for="(
                          item, index
                        ) in demandDetail.ManpowerDemandEducationDegree"
                        :key="item.EducationDegreeGuid"
                      >
                        <span v-if="index > 0">、</span>
                        {{ item.EducationDegree }}
                      </span>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>科系</span>
                </td>

                <td colspan="3">
                  <div v-if="is_editing">
                    <div
                      v-for="(
                        item, index
                      ) in demandDetail.ManpowerDemandSchoolDepartment"
                      :key="index"
                      style="margin-bottom: 20px"
                    >
                      <span class="language-title">
                        {{ item.SchoolDepartmentType }}
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click="deleteItem(index, 'Education')"
                        >
                          <eva-icon fill="#FFF" name="trash-2-outline" />
                        </button>
                      </span>
                      <h6 style="margin-bottom: 12px">
                        <span class="language-text">
                          {{
                            item.SchoolDepartment ? item.SchoolDepartment : null
                          }}
                          <span v-if="item.SchoolDepartmentDescription">
                            ｜科系描述：{{ item.SchoolDepartmentDescription }}
                          </span>
                        </span>
                      </h6>
                    </div>
                    <div>
                      <AddMajor
                        v-if="addMajor"
                        @addMajor="saveItem"
                        @addCancel="cancelItem('Education')"
                      />
                      <button
                        v-else
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="addItem('Education')"
                      >
                        <i class="fas fa-plus"></i> 新增科系
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="demandDetail.SchoolDepartmentWhatever">
                      不拘
                    </span>
                    <template v-else>
                      <div
                        v-for="(
                          item, index
                        ) in demandDetail.ManpowerDemandSchoolDepartment"
                        :key="index"
                      >
                        <span class="language-title">
                          {{ item.SchoolDepartmentType }}
                        </span>
                        <h6 style="margin-bottom: 12px">
                          {{
                            item.SchoolDepartment ? item.SchoolDepartment : null
                          }}
                          <span v-if="item.SchoolDepartmentDescription">
                            ｜科系描述：{{ item.SchoolDepartmentDescription }}
                          </span>
                        </h6>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span>外語</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div
                      v-for="(
                        item, index
                      ) in demandDetail.ManpowerDemandLanguage"
                      :key="index"
                      style="margin-bottom: 20px"
                    >
                      <span class="language-title">{{ item.Language }}</span>
                      <h6 style="margin-bottom: 12px">
                        <span class="language-text">聽：{{ item.Listen }}</span
                        >｜
                        <span class="language-text">說：{{ item.Speak }}</span
                        >｜
                        <span class="language-text">讀：{{ item.Read }}</span
                        >｜
                        <span class="language-text">寫：{{ item.Write }}</span>
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click="deleteItem(index, 'Language')"
                        >
                          <eva-icon fill="#FFF" name="trash-2-outline" />
                        </button>
                      </h6>
                    </div>
                    <AddLanguage
                      v-if="addLanguage"
                      @addLanguage="saveItem"
                      @addCancel="cancelItem('Language')"
                    />
                    <button
                      v-else
                      type="button"
                      class="btn btn-primary btn-sm"
                      @click="addItem('Language')"
                    >
                      <i class="fas fa-plus"></i> 新增外語
                    </button>
                  </div>
                  <div v-else>
                    <span v-if="languageStatus">不拘</span>
                    <template v-else>
                      <div
                        v-for="(
                          item, index
                        ) in demandDetail.ManpowerDemandLanguage"
                        :key="index"
                      >
                        <span class="language-title">{{ item.Language }}</span>
                        <h6 style="margin-bottom: 12px">
                          <span class="language-text"
                            >聽：{{ item.Listen }}</span
                          >｜
                          <span class="language-text">說：{{ item.Speak }}</span
                          >｜
                          <span class="language-text">讀：{{ item.Read }}</span
                          >｜
                          <span class="language-text"
                            >寫：{{ item.Write }}</span
                          >
                        </h6>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="1" class="text-right">
                  <span>方言</span>
                </td>
                <td colspan="3">
                  <div v-if="is_editing">
                    <div
                      v-for="(
                        item, index
                      ) in demandDetail.ManpowerDemandDialect"
                      :key="index"
                      style="margin-bottom: 20px"
                    >
                      <span class="language-title">{{
                        item.DialectDescription
                          ? item.DialectDescription
                          : item.Dialect
                      }}</span>
                      <h6 style="margin-bottom: 12px">
                        <span class="language-text">
                          程度：{{ item.Degree }}
                        </span>
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click="deleteItem(index, 'Dialect')"
                        >
                          <eva-icon fill="#FFF" name="trash-2-outline" />
                        </button>
                      </h6>
                    </div>
                    <AddDialect
                      v-if="addDialect"
                      @addDialect="saveItem"
                      @addCancel="cancelItem('Dialect')"
                    />
                    <button
                      v-else
                      type="button"
                      class="btn btn-primary btn-sm"
                      @click="addItem('Dialect')"
                    >
                      <i class="fas fa-plus"></i> 新增方言
                    </button>
                  </div>
                  <div v-else>
                    <span v-if="dialectStatus">不拘</span>
                    <template v-else>
                      <div
                        v-for="(
                          item, index
                        ) in demandDetail.ManpowerDemandDialect"
                        :key="index"
                      >
                        <span class="language-title">{{
                          item.DialectDescription
                            ? item.DialectDescription
                            : item.Dialect
                        }}</span>
                        <p>程度：{{ item.Degree }}</p>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right" colspan="1">
                  <span>駕照</span>
                </td>

                <td colspan="3">
                  <div v-if="is_editing">
                    <el-cascader
                      class="w-100"
                      :options="driverLicenses"
                      clearable
                      filterable
                      :props="props"
                      :show-all-levels="false"
                      @change="driverLicensesChange"
                      v-model="manpowerDemandDriverLicense"
                    />
                  </div>
                  <div v-else>
                    <span v-if="driverLicenseStatus">不拘</span>
                    <template v-else>
                      <span
                        v-for="(
                          item, index
                        ) in demandDetail.ManpowerDemandDriverLicense"
                        :key="index"
                      >
                        <span v-if="index > 0">、</span>{{ item.DriverLicense }}
                      </span>
                    </template>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right" colspan="1">
                  <span>證照</span>
                </td>
                <td colspan="3">
                  <template v-if="is_editing">
                    <el-cascader
                      class="w-100"
                      :options="certifications"
                      clearable
                      filterable
                      :props="props"
                      :show-all-levels="false"
                      :filter-method="certificationsFilter"
                      @change="certificationsChange"
                      v-model="chooseCertifications"
                    />
                    <ValidationProvider
                      v-if="certificateOther"
                      tag="section"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <textarea
                        v-model="certificateDescription"
                        class="form-control mt-2"
                        rows="5"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </template>
                  <div v-else>
                    <div
                      v-for="category in Object.keys(showCertifications)"
                      :key="category"
                    >
                      <span class="mr-2">{{ category }}</span>
                      <span
                        v-for="(item, index) in showCertifications[category]"
                        :key="index"
                      >
                        {{
                          item.CertificateDescription
                            ? item.CertificateDescription
                            : item.Certificate
                        }}
                        <span
                          v-if="
                            index !== showCertifications[category].length - 1
                          "
                          >、</span
                        >
                      </span>
                      <br />
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td class="text-right" colspan="1">
                  <span>其他條件</span>
                </td>
                <td colspan="3">
                  <textarea
                    v-if="is_editing"
                    class="form-control"
                    maxlength="500"
                    rows="3"
                    v-model="demandDetail.OtherConditions"
                  ></textarea>
                  <div v-else>
                    <pre>{{ demandDetail.OtherConditions }}</pre>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import AddLanguage from "@/components/back/DemandForm/AddLanguage.vue";
import AddDialect from "@/components/back/DemandForm/AddDialect.vue";
import AddMajor from "@/components/back/DemandForm/AddMajor.vue";

export default {
  name: "DemandEdit",

  components: {
    AddLanguage,
    AddDialect,
    AddMajor,
  },
  data() {
    return {
      is_composing: false, // compositionstart& compositionend

      is_editing: false, //編輯狀態

      addMajor: false, // 新增科系
      addLanguage: false, // 新增外語
      addDialect: false, //新增方言

      driverLicenseStatus: false,
      recruitmentMethodStatus: false, // 招募方式
      workingHoursStatus: false, // 工作方式
      languageStatus: false, //外語
      dialectStatus: false, //方言

      // 履歷類型
      resumeTypeLIst: [],

      // 需求單資料
      demandDetail: {},

      // 職務列表
      positionList: [],
      positionValue: {},

      // 工作地點列表
      workplaceList: [],

      // 班別
      workingHours: [],
      newWorkingHours: [], // copy workingHours
      showWorkShiftType: [],
      workShiftTypeDescription: [],

      // 學歷
      educationDegree: [],

      // 證照
      certifications: [],
      certificateOther: false,
      certificateDescription: null,
      chooseCertifications: [],
      showCertifications: [],

      // 駕照
      driverLicenses: [],
      manpowerDemandDriverLicense: [],

      // 薪資類型
      salaryTypeList: [],
      salaryTypeValue: {},
      salaryTypeDescription: null,

      // 招募方式
      showRecruitmentMethod: [],
      recruitmentMethod: [],
      recruitmentMethodOtherStatus: false, // 招募狀態是否選其他
      recruitmentMethodDescription: null, // 招募方式描述

      // 簽核主管
      supervisorOptions: [], // 列表
      supervisorData: null, // (Guid & Name)

      // el-cascader
      props: { multiple: true },
    };
  },

  watch: {
    "demandDetail.SalaryLow": function (newVal) {
      if (newVal) {
        this.demandDetail.SalaryLow = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
    "demandDetail.SalaryHigh": function (newVal) {
      if (newVal) {
        this.demandDetail.SalaryHigh = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    "demandDetail.AppointmentDefaultSalary": function (newVal) {
      if (newVal) {
        this.demandDetail.AppointmentDefaultSalary =
          this.$common.currencyThousands(String(newVal));
      }
    },

    // 職務名稱
    "demandDetail.PositionProperty": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.get_position(this.demandDetail.PositionProperty)
          .then((result) => {
            this.positionList = result;
          })
          .catch((error) =>
            this.$notify({
              title: "職務列表取得失敗",
              message: error.response.data,
              type: "error",
              duration: 3500,
            })
          );
      }
    },

    // 招募方式
    "demandDetail.ManpowerDemandRecruitmentMethod": function (e) {
      if (e) {
        const arr = e.map((item) => item.RecruitmentMethodCode);
        if (arr.includes("other")) {
          this.recruitmentMethodOtherStatus = true;
        } else {
          this.recruitmentMethodOtherStatus = false;
          this.recruitmentMethodDescription = null;
        }
      }
    },

    // 證照
    "demandDetail.ManpowerDemandCertificate": function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        const foundOther = newVal.filter((item) => {
          return item.CertificateCode.indexOf("other") === 0;
        });
        if (foundOther.length === 0) {
          this.certificateDescription = null;
        }
      }
    },

    // 職務聯絡人
    "demandDetail.PositionContactor": function (e) {
      this.demandDetail.PositionContactorEmail = e ? e.Email : null;
    },
  },

  methods: {
    // 取得需求單詳細資訊 API
    getDemandDetail() {
      const vm = this;
      const demandGuid = localStorage.demandGuid;
      const api = `${window.endpoints.api}/ManpowerDemandModule/${demandGuid}`;

      // 定義本地 groupBy 函數
      function groupBy(array, prop) {
        return array.reduce((groups, item) => {
          const val = item[prop];
          if (!groups[val]) {
            groups[val] = [];
          }
          groups[val].push(item);
          return groups;
        }, {});
      }

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.demandDetail = response.data;

            // 檢視顯示的招募方式
            vm.showRecruitmentMethod =
              vm.demandDetail.ManpowerDemandRecruitmentMethod.map((item) => {
                return { ...item };
              });

            // 檢視顯示的工作時間
            vm.showWorkShiftType =
              vm.demandDetail.ManpowerDemandWorkShiftType.map((item) => {
                return { ...item };
              });

            // 證照(其他)描述
            vm.certificateDescription = null;

            // 班別
            vm.newWorkingHours = vm.workingHours.map((item) => {
              return { ...item };
            });
            vm.newWorkingHours.forEach((o1, index, arr) =>
              vm.demandDetail.ManpowerDemandWorkShiftType.map((o2) => {
                if (o1.WorkShiftTypeGuid === o2.WorkShiftTypeGuid) {
                  arr[index].WorkShiftTypeDescription =
                    o2.WorkShiftTypeDescription;
                }
              })
            );
            vm.demandDetail.ManpowerDemandWorkShiftType =
              vm.newWorkingHours.filter((o1) =>
                vm.demandDetail.ManpowerDemandWorkShiftType.some(
                  (o2) => o1.WorkShiftTypeGuid === o2.WorkShiftTypeGuid
                )
              );
            // 班別(不拘)
            vm.workingHoursStatus =
              vm.demandDetail.ManpowerDemandWorkShiftType.length === 0;

            // 招募方式(其他)
            vm.demandDetail.ManpowerDemandRecruitmentMethod.forEach(
              (element) => {
                vm.recruitmentMethodDescription =
                  element.RecruitmentMethodDescription || "";
              }
            );

            // 招募方式列表
            vm.demandDetail.ManpowerDemandRecruitmentMethod =
              vm.recruitmentMethod.filter((o1) =>
                vm.demandDetail.ManpowerDemandRecruitmentMethod.some(
                  (o2) => o1.RecruitmentMethodGuid === o2.RecruitmentMethodGuid
                )
              );
            // 招募方式(不拘)
            vm.recruitmentMethodStatus =
              vm.demandDetail.ManpowerDemandRecruitmentMethod.length === 0;

            // 工作地點
            vm.demandDetail.ManpowerDemandWorkPlace =
              vm.demandDetail.ManpowerDemandWorkPlace.map((item) => {
                return {
                  WorkPlaceGuid: item.WorkPlaceGuid,
                  WorkPlace: item.WorkPlace,
                };
              });

            // 學歷
            vm.demandDetail.ManpowerDemandEducationDegree =
              vm.educationDegree.filter((o1) =>
                vm.demandDetail.ManpowerDemandEducationDegree.some(
                  (o2) => o1.EducationDegreeGuid === o2.EducationDegreeGuid
                )
              );

            // 外語
            vm.languageStatus =
              vm.demandDetail.ManpowerDemandLanguage.length < 1;

            // 方言
            vm.dialectStatus = vm.demandDetail.ManpowerDemandDialect.length < 1;

            // 駕照 el-cascader
            vm.manpowerDemandDriverLicense =
              vm.demandDetail.ManpowerDemandDriverLicense.map((category) => {
                return [
                  `${category.DriverLicenseCategory}`,
                  `${category.DriverLicenseGuid}+${category.DriverLicense}`,
                ];
              });
            // 駕照 array
            vm.demandDetail.ManpowerDemandDriverLicense =
              vm.demandDetail.ManpowerDemandDriverLicense.map((item) => {
                return {
                  DriverLicenseCategory: item.DriverLicenseCategory,
                  DriverLicenseGuid: item.DriverLicenseGuid,
                  DriverLicense: item.DriverLicense,
                };
              });
            // 駕照(不拘)
            vm.driverLicenseStatus =
              vm.demandDetail.ManpowerDemandDriverLicense.length < 1;

            // 證照(檢視)分群組
            vm.showCertifications = groupBy(
              vm.demandDetail.ManpowerDemandCertificate,
              "CertificateCategorySecond"
            );

            // 證照來源(扁平化)
            const flatten = (data) => {
              return data.reduce((r, { children, ...rest }) => {
                r.push(rest);
                if (children) r.push(...flatten(children));
                return r;
              }, []);
            };
            let flatCertifications = flatten(vm.certifications);
            let filterCertifications = flatCertifications.filter((o1) =>
              vm.demandDetail.ManpowerDemandCertificate.some(
                (o2) => o1.value.split("+")[0] === o2.CertificateGuid
              )
            );
            vm.demandDetail.ManpowerDemandCertificate.forEach(
              (o1, index, arr) =>
                filterCertifications.map((o2) => {
                  if (o1.CertificateGuid === o2.value.split("+")[0]) {
                    arr[index].CertificateCode = o2.value.split("+")[2];
                  }
                })
            );
            // 證照 el-cascader
            vm.chooseCertifications =
              vm.demandDetail.ManpowerDemandCertificate.map((category) => {
                return [
                  `${category.CertificateCategoryTop}`,
                  `${category.CertificateCategorySecond}`,
                  `${category.CertificateGuid}+${category.Certificate}+${category.CertificateCode}`,
                ];
              });
            // 證照 array
            vm.demandDetail.ManpowerDemandCertificate =
              vm.demandDetail.ManpowerDemandCertificate.map((item) => {
                if (item.CertificateDescription) {
                  vm.certificateOther = true;
                  vm.certificateDescription = item.CertificateDescription;
                }
                return {
                  CertificateCategoryTop: item.CertificateCategoryTop,
                  CertificateCategorySecond: item.CertificateCategorySecond,
                  CertificateGuid: item.CertificateGuid,
                  Certificate: item.Certificate,
                  CertificateCode: item.CertificateCode,
                  CertificateDescription: item.CertificateDescription,
                };
              });

            // 職務名稱
            vm.positionValue.PositionCode = vm.demandDetail.PositionCode;
            vm.positionValue.PositionName = vm.demandDetail.PositionName;

            // 薪資類型
            vm.salaryTypeValue.Code = vm.demandDetail.SalaryTypeDescription
              ? "other"
              : null;
            vm.salaryTypeValue.Guid = vm.demandDetail.SalaryTypeGuid;
            vm.salaryTypeValue.Name = vm.demandDetail.SalaryType;
            vm.salaryTypeDescription = vm.demandDetail.SalaryTypeDescription;

            // 職務聯絡人
            const PositionContactorData = {
              Name: vm.demandDetail.PositionContactor,
              Email: vm.demandDetail.PositionContactorEmail,
            };
            vm.demandDetail.PositionContactor = vm.supervisorOptions.filter(
              (o1) => PositionContactorData.Email === o1.Email
            );

            if (vm.demandDetail.PositionContactor.length > 0) {
              vm.demandDetail.PositionContactor =
                vm.demandDetail.PositionContactor[0];
            } else {
              vm.supervisorOptions.push(PositionContactorData);
              vm.demandDetail.PositionContactor = PositionContactorData;
            }

            vm.$nextTick(() => {
              vm.$store.dispatch("updateLoading", false);
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "需求單資料取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 儲存需求單 API
    saveDemand() {
      const vm = this;
      const api = `${window.endpoints.api}/ManpowerDemandModule`;

      // 薪資類型
      if (vm.salaryTypeValue?.Code !== "other") {
        vm.demandDetail.SalaryTypeDescription = null;
      }

      const data = {
        ...vm.demandDetail,
        UpdateUser: vm.$cookies.get("userName"),
        ManpowerDemandRecord: [],
      };

      if (data.ManpowerDemandStatus === "New") {
        data.ManpowerDemandRecord = [];
      }

      // 科系要求
      data.SchoolDepartmentWhatever =
        data.ManpowerDemandSchoolDepartment.length === 0;

      // 管理人數
      if (!data.ManagementResponsibility) {
        data.ManagementNumber = null;
      }
      // 年齡
      if (data.AgeRangeWhatever) {
        data.AgeRangeStart = 18;
        data.AgeRangeEnd = 80;
      }

      // 工作經驗
      if (data.WorkExperienceWhatever) {
        data.WorkExperience = null;
      }

      // 學歷
      if (data.EducationDemandWhatever) {
        data.ManpowerDemandEducationDegree = [];
      }

      // 證照
      data.ManpowerDemandCertificate = data.ManpowerDemandCertificate.map(
        (item) => {
          return {
            ...item,
            CertificateDescription:
              item.CertificateCode === "other"
                ? vm.certificateDescription
                : null,
          };
        }
      );

      // 職務聯絡人
      data.PositionContactor = data.PositionContactor.Name;

      // 職務名稱
      data.PositionCode = vm.positionValue.PositionCode;
      data.PositionName = vm.positionValue.PositionName;

      // 招募方式
      data.ManpowerDemandRecruitmentMethod =
        data.ManpowerDemandRecruitmentMethod.map((item) => {
          return {
            RecruitmentMethodGuid: item.RecruitmentMethodGuid,
            RecruitmentMethod: item.RecruitmentMethod,
            RecruitmentMethodDescription:
              item.RecruitmentMethodCode === "other"
                ? vm.recruitmentMethodDescription
                : null,
          };
        });

      // 薪資類型
      data.SalaryTypeGuid = vm.salaryTypeValue.Guid;
      data.SalaryType = vm.salaryTypeValue.Name;

      data.SalaryLow = data.SalaryLow
        ? Number(data.SalaryLow.replace(/,/g, ""))
        : null;

      data.SalaryHigh = data.SalaryHigh
        ? Number(data.SalaryHigh.replace(/,/g, ""))
        : null;

      data.AppointmentDefaultSalary = data.AppointmentDefaultSalary
        ? Number(data.AppointmentDefaultSalary.replace(/,/g, ""))
        : null;

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .put(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.is_editing = false;
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "需求單儲存成功",
              type: "success",
              duration: 2500,
            });
            vm.getDemandDetail();
          }
        })
        .catch((error) => {
          vm.cancelEditDemand();
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "儲存失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 搜尋證照關鍵字(不區分大小寫)
    certificationsFilter(node, keyword) {
      if (
        !!~node.text.indexOf(keyword) ||
        !!~node.text.toUpperCase().indexOf(keyword.toUpperCase())
      ) {
        return true;
      }
    },

    // 選擇證照
    certificationsChange(value) {
      if (value.length === 0) {
        this.certificateOther = false;
        this.certificateDescription = null;
      } else {
        let findOther = value
          .map((item) => {
            return item[2].split("+")[2];
          })
          .indexOf("other");
        if (findOther === -1) {
          this.certificateOther = false;
          this.certificateDescription = null;
        } else {
          this.certificateOther = true;
        }
        this.demandDetail.ManpowerDemandCertificate = value.map((item) => {
          return {
            CertificateCategoryTop: item[0],
            CertificateCategorySecond: item[1],
            CertificateGuid: item[2].split("+")[0],
            Certificate: item[2].split("+")[1],
            CertificateCode: item[2].split("+")[2],
            CertificateDescription:
              item[2].split("+")[2] === "other"
                ? this.certificateDescription
                : null,
          };
        });
      }
    },

    // 取消編輯
    cancelEditDemand() {
      this.is_editing = false;
      this.addMajor = false;
      this.addLanguage = false;
      this.addDialect = false;
      this.newWorkingHours = this.workingHours.map((item) => {
        return { ...item };
      });
      this.getDemandDetail();
    },

    // 取得履歷類型
    getResumeType() {
      const vm = this;
      const api = `${window.endpoints.api}/ResumeModule/ResumeTypes/Enable`;

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.resumeTypeLIst = response.data;
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "履歷類型取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 新增 科系& 語言& 方言 元件
    addItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = true;
          break;
        case "Dialect":
          this.addDialect = true;
          break;
        case "Education":
          this.addMajor = true;
          break;
      }
    },

    // 取消新增 科系& 語言& 方言 元件
    cancelItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = false;
          break;
        case "Dialect":
          this.addDialect = false;
          break;
        case "Education":
          this.addMajor = false;
          break;
      }
    },

    // 儲存 科系 & 語言 & 方言 元件
    saveItem(item, type) {
      const configMap = {
        Education: {
          flag: "addMajor",
          list: "ManpowerDemandSchoolDepartment",
          matchKeys: ["SchoolDepartmentGuid", "SchoolDepartmentDescription"],
        },
        Language: {
          flag: "addLanguage",
          list: "ManpowerDemandLanguage",
          matchKeys: ["LanguageGuid", "LanguageDescription"],
        },
        Dialect: {
          flag: "addDialect",
          list: "ManpowerDemandDialect",
          matchKeys: ["DialectGuid", "DialectDescription"],
        },
      };

      const config = configMap[type];
      if (!config) return;

      // 1. 設定 flag 為 false
      this[config.flag] = false;

      // 2. 取得對應列表
      const list = this.demandDetail[config.list];

      // 3. 找出是否已有相同項目
      const index = list.findIndex((element) =>
        config.matchKeys.every((key) => element[key] === item[key])
      );

      // 4. 根據 index 新增或更新項目
      if (index === -1) {
        list.push({ ...item });
      } else {
        list.splice(index, 1, { ...item });
      }
    },

    // 刪除 科系 & 語言 & 方言 元件
    deleteItem(itemIndex, category) {
      switch (category) {
        case "Education":
          this.demandDetail.ManpowerDemandSchoolDepartment.forEach(
            (item, index) => {
              if (itemIndex === index) {
                this.demandDetail.ManpowerDemandSchoolDepartment.splice(
                  index,
                  1
                );
              }
            }
          );
          break;
        case "Language":
          this.demandDetail.ManpowerDemandLanguage.forEach((item, index) => {
            if (itemIndex === index) {
              this.demandDetail.ManpowerDemandLanguage.splice(index, 1);
            }
          });
          break;
        case "Dialect":
          this.demandDetail.ManpowerDemandDialect.forEach((item, index) => {
            if (itemIndex === index) {
              this.demandDetail.ManpowerDemandDialect.splice(index, 1);
            }
          });
          break;
      }
    },

    // 取得證照
    getCertifications() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/CertificateCategory/WithDetail`;

      // 將單一證照映射成想要的格式
      function mapCertificate(certificate) {
        return {
          label: certificate.Name,
          value: `${certificate.Guid}+${certificate.Name}+${certificate.Code}`,
        };
      }

      // 將分類映射成格式，並包含子證照
      function mapCategory(category) {
        return {
          label: category.Name,
          value: category.Name,
          children: category.Certificates.map(mapCertificate),
        };
      }

      // 將證照類型映射成格式，並包含子分類
      function mapType(type) {
        return {
          label: type.Name,
          value: type.Name,
          children: type.Children.map(mapCategory),
        };
      }

      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.certifications = response.data.map(mapType);
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "證照列表取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 取得駕照
    getDriverLicenses() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/DriverLicenseCategory/WithDetail`;

      const params = {
        IsEnable: true,
      };

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.driverLicenses = response.data.map((category) => {
              return {
                label: category.Name,
                value: category.Name,
                children: category.DriverLicenses.map((driverLicense) => {
                  return {
                    label: driverLicense.Name,
                    value: `${driverLicense.Guid}+${driverLicense.Name}`,
                  };
                }),
              };
            });
          }
        })
        .catch((error) => {
          vm.$notify({
            title: "駕照列表取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 選擇駕照
    driverLicensesChange(value) {
      this.demandDetail.ManpowerDemandDriverLicense = value.map((item) => {
        return {
          DriverLicenseCategory: item[0],
          DriverLicenseGuid: item[1].split("+")[0],
          DriverLicense: item[1].split("+")[1],
        };
      });
    },

    // 職務聯絡人
    addPositionContactorTag(newTag) {
      const tag = {
        Name: newTag,
        Guid: `${newTag.substring(0, 3)}-${crypto.randomUUID()}`,
      };
      this.supervisorOptions.push(tag);
      this.demandDetail.PositionContactor = tag;
    },

    async getData() {
      // 取得主管列表
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Name: user.Name,
          Email: user.Email,
        };
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "/manager/recruitment/personalapplication") {
        vm.$router.push("/refresh");
      }
    });
  },

  created() {
    this.getData();
    this.getResumeType();
    this.getCertifications();
    this.getDriverLicenses();

    // 取得職務列表
    this.get_position(null)
      .then((result) => {
        this.positionList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "職務列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );

    this.$http
      .all([
        this.get_workplace(),
        this.get_working_hours(),
        this.get_education_degree(),
        this.get_recruitment_method(),
        this.get_salary_type(),
      ])
      .then(
        this.$http.spread(
          (
            workplace,
            working_hours,
            education_degree,
            recruitment_method,
            salary_type
          ) => {
            this.workplaceList = workplace.map((item) => {
              return {
                WorkPlaceGuid: item.Guid,
                WorkPlace: item.WorkPlaceName,
              };
            });
            this.workingHours = working_hours;
            this.educationDegree = education_degree;
            this.recruitmentMethod = recruitment_method.map((item) => {
              return {
                RecruitmentMethodCode: item.Code,
                RecruitmentMethodGuid: item.Guid,
                RecruitmentMethod: item.Name,
              };
            });
            this.salaryTypeList = salary_type;
            this.getDemandDetail();
          }
        )
      );
  },
};
</script>

<style lang="scss">
$color1: #636f83;
.demand-detail-edit-page {
  padding-bottom: 60px;
  .demand-edit-wrap {
    position: fixed;
    bottom: 30px;
    right: 20px;
    padding: 10px 15px;
    text-align: center;
    z-index: 11;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    border-radius: 42px;
    border: 3px solid #ffc727;
    button {
      border: none;
      padding: 5px 10px;
      border-radius: 25px;
      margin-right: 5px;
      transition: all 0.2s;

      &:hover {
        background-color: #5380f7;
        color: #fff;
        svg.eva {
          fill: #fff;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}
th {
  font-weight: normal;
}
</style>
